import { useCallback, useEffect, useMemo, useState } from 'react';
import { guestService } from '../services/guestService';
import { findGuestByUserId } from '../utils/guestUtils';

export default function useGuests(eventId, userId) {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(Boolean(eventId));
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!eventId) {
      setGuests([]);
      setLoading(false);
      setError(null);
      return [];
    }

    setLoading(true);
    setError(null);

    try {
      const nextGuests = await guestService.getGuests(eventId);
      setGuests(nextGuests);
      return nextGuests;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    let active = true;

    if (!eventId) {
      setGuests([]);
      setLoading(false);
      setError(null);
      return undefined;
    }

    setLoading(true);
    setError(null);

    guestService.getGuests(eventId)
      .then((nextGuests) => {
        if (active) setGuests(nextGuests);
      })
      .catch((requestError) => {
        if (active) setError(requestError);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [eventId]);

  const guestProfile = useMemo(
    () => findGuestByUserId(guests, userId),
    [guests, userId]
  );

  return {
    guests,
    guestProfile,
    loading,
    error,
    refresh,
  };
}
